import { useField } from 'formik';
import styled from 'styled-components';
import {
  Stack,
  PopoverItem as RawPopoverItem,
  PopoverMenu as RawPopoverMenu,
} from '@koob/margaret';
import { FormField, Text } from 'ui';
import { KoobInputStepper, KoobTableAction } from '@koob/ui';
import { useTranslation } from 'react-i18next';

const PopoverMenu = styled(RawPopoverMenu)`
  position: static;
  border: solid 1px ${({ theme }) => theme.separator};
  box-shadow: 0 1px 2px 0 ${({ theme }) => theme.shadow};
  border-radius: 8px;
  max-height: 350px;
  &:hover {
    border: solid 1px ${({ theme }) => theme.darkSeparator};
  }
`;

const PopoverItem = styled(RawPopoverItem)`
  padding: ${({ theme }) => theme.spacing(0.5)}
    ${({ theme }) => theme.spacing()};
  color: ${({ theme }) => theme.textLight};
`;

const EditSelectedFacilitiesField = ({ disabled, name }) => {
  const { t } = useTranslation();
  const [{ value: beds }, , { setValue }] = useField({ name });

  const handleBedCountChange = (selectedBedIndex, newBedCount) => {
    const draft = [...beds];

    draft[selectedBedIndex].bedCount = newBedCount;
    setValue(draft);
  };

  const handleDeleteBed = (selectedBedIndex) => {
    const draft = [...beds];

    draft.splice(selectedBedIndex, 1);
    setValue(draft);
  };

  return (
    <FormField>
      {beds.length > 0 && (
        <PopoverMenu>
          {beds.map((bed, index) => (
            <PopoverItem key={bed.bedId}>
              <Stack
                gutterSize={0.5}
                alignY="center"
                alingX="space-between"
                size="full"
              >
                <Stack gutterSize={0.5} alignY="center" size="full">
                  <i className="fa-light fa-bed" style={{ fontSize: 24 }} />
                  <Text type="body">
                    {bed.displayName}{' '}
                    {bed.minCapacity !== bed.maxCapacity ? (
                      <Text type="bodySmall" color="textLight">
                        ({bed.minCapacity}{' '}
                        <i className="fal fa-arrows-left-right text-gray-400" />{' '}
                        {bed.maxCapacity})
                      </Text>
                    ) : (
                      ` (${bed.minCapacity})`
                    )}
                  </Text>
                </Stack>

                {!disabled ? (
                  <Stack gutterSize={1.5} alignY="center">
                    <KoobInputStepper
                      value={bed.bedCount}
                      min={1}
                      onValueChange={(newBedCount) => {
                        handleBedCountChange(index, newBedCount);
                      }}
                    />
                    <KoobTableAction
                      icon="delete"
                      label={t('misc:delete')}
                      variant="danger"
                      onClick={() => handleDeleteBed(index)}
                    />
                  </Stack>
                ) : (
                  <Stack>
                    <Text type="body">{bed.bedCount}</Text>
                  </Stack>
                )}
              </Stack>
            </PopoverItem>
          ))}
        </PopoverMenu>
      )}
    </FormField>
  );
};

export default EditSelectedFacilitiesField;
